import { SceneObjects } from '@types'
import { toVector3 } from './conversion/toVector3'
import { degrees } from './generalMaths/geometry'

export const getInitialAngleDegrees = (item: SceneObjects): number => {
  const x = toVector3()
  const y = toVector3()
  const z = toVector3()

  // Extraer las bases de la matriz del item
  item.matrix.extractBasis(x, y, z)

  // Calcular el ángulo de rotación en el eje X
  const xRot = toVector3([1, 0, 0]).angleTo(x)

  // Calcular el producto cruzado. A 180° los ejes son opuestos y el producto es 0:
  // Math.sign(0) dejaba el ángulo en 0, y la fila de detrás de una isla se leía
  // como si mirase igual que la de delante. La encimera continua del centro no pintaba.
  const crossY = toVector3([1, 0, 0]).cross(x).y
  let sign = Math.sign(crossY)
  if (sign === 0) sign = x.x < 0 ? -1 : 1

  const initialAngleDegrees = (degrees(xRot * -sign) + 360) % 360

  return initialAngleDegrees
}
